import { render } from "./search-ads.vue?vue&type=template&id=53356711"
import script from "./search-ads.js?vue&type=script&lang=js"
export * from "./search-ads.js?vue&type=script&lang=js"

import "./search-ads.vue?vue&type=style&index=0&id=53356711&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__